import { useState, useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Button,
    ButtonBase,
    ClickAwayListener,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Typography,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';

// assets
import { IconMenu2, IconNews } from '@tabler/icons';
import { getAuth, signOut } from "firebase/auth";
import { useDispatch } from 'react-redux';
import { SET_MENU } from 'store/actions';
import { useTranslation } from 'react-i18next'
import sanityClient from "sanityClient.js";

// ==============================|| PROFILE MENU ||============================== //

const AuxMenuSection = (props) => {
    // const { open, setOpen } = props;
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();

    // const [sdm, setSdm] = useState(true);
    // const [value, setValue] = useState('');
    // const [notification, setNotification] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const auth = getAuth();
    const dispatch = useDispatch();
    const { t } = useTranslation(); 
    const [footerArticles, setFooterArticles] = useState([]);
    const lang = localStorage.getItem('allserv-lang');
    const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);
    const handleLogout = async () => {
        // console.log('Logout');
        signOut(auth)
        .then(() => {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('mytoken');
            sessionStorage.removeItem('username');
            sessionStorage.removeItem('permissions');
            sessionStorage.removeItem('userID');
            sessionStorage.removeItem('companyID');
            sessionStorage.removeItem('photoURL');

            // and this is to make sure next time there will be auth window shown without autologin
            localStorage.removeItem('username');
            localStorage.removeItem('userID');
            localStorage.removeItem('token');
            localStorage.removeItem('photoURL');
            localStorage.removeItem('permissions');
            localStorage.removeItem('mytoken');

            dispatch({ type: SET_MENU, opened: false }); // to close left drawer
            // navigate(`/`);
            window.location.href='/'; // this is to reload app, bacuse login as user with different permissions might require reload data in some components/menu
        })
        .catch((error) => {
          // An error happened.
            console.log(error);
        });
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListItemClick = (event, index, route = '') => {
        setSelectedIndex(index);
        handleClose(event);

        if (route && route !== '') {
            navigate(route);
        }
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;

        sanityClient
          .fetch(

            `*[_type == "post" && categories[]._ref == "f721b49f-4572-4291-801e-540e17e8a8e5"] | order(sortOrder asc) {
                title,
                titleRu,
                titleEl,
                slug,
                mainImage{
                  asset->{
                    _id,
                    url
                  }
                },
                body,
                bodyRu,
                bodyEl,
                categories,
                _id
              }`
          )
          .then((data) => {
              // console.log('FooterCard() sanityClient.fetch data:', data);
              setFooterArticles(data);
          })
          .catch(console.error);

    }, [open]);

    const singleArticle = (row) => {
        // console.log('singleArticle() row._id:', row._id);
        let title = '';
        // let body = '';
        switch (lang) {
            case 'ru':
                title = row?.titleRu? row.titleRu: row.title;
                // body = row?.bodyRu? row.bodyRu: row.body;
                break;
            case 'el':
                title = row?.titleEl? row.titleEl: row.title;
                // body = row?.bodyEl? row.bodyEl: row.body;
                break;
            default:
                title = row?.title;
                // body = row?.body;
        }
        // console.log('SingleArticle() row', row);

        return (
                <ListItemButton
                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                    selected={selectedIndex === row._id}
                    onClick={(event) => handleListItemClick(event, row._id, `/article/${row.slug.current}`)}
                >
                    <ListItemIcon>
                        <IconNews stroke={1.5} size="21" />
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant="body2">{title}</Typography>} />
                </ListItemButton>
        )
    }

    const aboutSection = () => {
        return (
            <>
                <Typography variant="h3">{t('menu-about')}</Typography>
                    {footerArticles.map((row) => {
                        return singleArticle(row);
                    }
                    )}
            </>
        );
    }

    return (
        <>
            <ButtonBase className='aux-menu-switch' sx={{ borderRadius: '12px', overflow: 'hidden', paddingLeft: 4 }}>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.secondary.light,
                        color: theme.palette.secondary.dark,
                        '&:hover': {
                            background: theme.palette.secondary.dark,
                            color: theme.palette.secondary.light
                        }
                    }}
                    onClick={handleToggle}
                    color="inherit"
                    ref={anchorRef}
                >
                    <IconMenu2 stroke={1.5} size="21" />
                </Avatar>
            </ButtonBase>
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={(window.innerWidth>600)? anchorRef.current: null}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        },
                    ]
                }}
                style={{ zIndex: 10 }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <PerfectScrollbar style={{ height: '100%', maxHeight: window.isWebView? 'calc(100vh - 50px)': 'calc(100vh - 150px)', overflowX: 'hidden' }}>
                                        <Box sx={{ p: 2 }}>
                                            
                                            <List
                                                component="nav"
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 350,
                                                    minWidth: 300,
                                                    backgroundColor: theme.palette.background.paper,
                                                    borderRadius: '10px',
                                                    [theme.breakpoints.down('md')]: {
                                                        minWidth: '100%'
                                                    },
                                                    '& .MuiListItemButton-root': {
                                                        mt: 0.5
                                                    }
                                                }}
                                            >
                                                {aboutSection()}
                                            </List>
                                        </Box>
                                    </PerfectScrollbar>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>
             <Dialog
                open={logoutDialogOpen}
                onClose={() => {handleLogout()}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
                {t('logout-dialog-title')}
            </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t('logout-dialog-text')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={() => {
                            setLogoutDialogOpen(false);
                            // navigate(`/`);
                            handleLogout();
                        }} 
                    autoFocus
                    >
                        {t('a-button-close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AuxMenuSection;
